import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  SwipeableDrawer,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import {
  ProjectItem,
  Section,
  ServiceItem,
  WhyChooseItem,
} from "../../components";
import SectionTitle from "../../components/Common/section-title.component";
import MainNav from "../../components/Nav/nav.component";
import classes from "./home.module.css";
import { Typewriter } from "react-simple-typewriter";

const Home = () => {
  const theme = useTheme();
  const mediumScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <>
      {/* <Container maxWidth="xl"> */}
      <Box
        mb={2}
        pt={3}
        textAlign={"center"}
        color={theme.palette.white.main}
        display="flex"
        flexWrap="wrap"
        flexDirection="column"
        justifyContent="space-between"
        minHeight={mediumScreen ? "calc(100vh - 100px)" : ""}
        style={{ background: "#003da5" }}
      >
        {/* Menu */}
        <MainNav></MainNav>

        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          justifyContent="space-between"
        >
          <Typography variant="h2" mt={5} mb={2} px={2}>
            Experts Freelance<br></br>
            <span
              style={{
                backgroundColor: "#ffc72c",
                color: "rgb(0, 61, 165)",
                paddingLeft: 10,
                paddingRight: 10,
                display: "inline-block",
              }}
            >
              <Typewriter
                words={["Mobile App", "Website", "Web App", "UI and UX"]}
                cursor={false}
                loop={0}
              />
            </span>
            {mediumScreen ? "" : <br></br>} Development<br></br>in Myanmar
          </Typography>
          <Box px={mediumScreen ? 10 : 0}>
            <img
              src={process.env.PUBLIC_URL + "/img/dashbord-img.png"}
              alt="dashboard"
              style={{ marginBottom: -4 }}
            ></img>
          </Box>
        </Box>
      </Box>
      {/* </Container> */}

      <Container maxWidth="xl">
        <Section
          id="about"
          style={{
            background:
              "linear-gradient(to top, rgba(203,225,244,0), rgba(203,225,244,1))",
          }}
          elevation={0}
          borderRadius={2}
        >
          <Container>
            <Grid container spacing={mediumScreen ? 4 : 8}>
              <Grid
                item
                md={6}
                sx={{
                  textAlign: { xs: "center", md: "start" },
                }}
              >
                <SectionTitle
                  normal="About"
                  highlight="NEX Solutions"
                  mb={3}
                ></SectionTitle>
                <Typography variant="body1">
                  We, NEXSolutions is a team of professionals developing all
                  kind of software solutions and delivering of UI/UX to our
                  clients and this has made NEXSolutions to be the best team. It
                  is our pleasure to upgrade your business with the best
                  solution and NEXSolutions is always standing by for you.
                </Typography>
                <Box
                  display={"flex"}
                  flexWrap={"wrap"}
                  mt={5}
                  gap={3}
                  sx={{
                    justifyContent: { xs: "center", md: "flex-start" },
                  }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/img/tech-logo/laravel.svg"}
                    alt="laravel"
                    style={{ height: 50 }}
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/img/tech-logo/flutter.svg"}
                    alt="flutter"
                    style={{ height: 50 }}
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/img/tech-logo/react.svg"}
                    alt="react"
                    style={{ height: 50 }}
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/img/tech-logo/Kotlin.svg"}
                    alt="Kotlin"
                    style={{ height: 50 }}
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/img/tech-logo/swift.svg"}
                    alt="swift"
                    style={{ height: 50 }}
                  />
                  <img
                    src={
                      process.env.PUBLIC_URL + "/img/tech-logo/wordpress.svg"
                    }
                    alt="wordpress"
                    style={{ height: 50 }}
                  />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  gap={4}
                  justifyContent={"center"}
                >
                  <Box className={classes.yearCircle}>
                    <Typography variant="h1" color={theme.palette.primary.main}>
                      8+
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h4" fontWeight={"normal"}>
                      YEARS OF
                    </Typography>
                    <Typography variant="h4">EXPERIENCE</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Section elevation={0} padding="bottom" id="services">
          <SectionTitle
            normal="We Offer A Wide Variety Of"
            highlight="IT Services"
            textAlign="center"
          />
          <Container>
            <Grid container spacing={5}>
              <Grid item md={4}>
                <ServiceItem
                  title="Web Development"
                  imgUrl={
                    process.env.PUBLIC_URL + "/img/services/website-mockup.png"
                  }
                />
              </Grid>
              <Grid item md={4}>
                <ServiceItem
                  title="App Development"
                  imgUrl={
                    process.env.PUBLIC_URL + "/img/services/app-mockup.png"
                  }
                />
              </Grid>
              <Grid item md={4}>
                <ServiceItem
                  title="UI/UX"
                  imgUrl={process.env.PUBLIC_URL + "/img/services/ui-ux-2.png"}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Section
          style={{
            background:
              "linear-gradient(to top, rgba(7, 129, 160, 0), rgb(0, 61, 165))",
            borderRadius: 8,
          }}
          elevation={0}
          id="showcase"
        >
          <SectionTitle
            normal="Our marvelous works"
            textAlign="center"
            color={theme.palette.white.main}
          ></SectionTitle>
          <Container>
            <Grid container spacing={5}>
              <Grid item md={4} xs={11} mx={"auto"}>
                <ProjectItem
                  imgUrl={
                    process.env.PUBLIC_URL + "/img/projects/project-1.jpg"
                  }
                  title="Personal Portfolio"
                ></ProjectItem>
              </Grid>
              <Grid item md={4} xs={11} mx={"auto"}>
                <ProjectItem
                  imgUrl={
                    process.env.PUBLIC_URL + "/img/projects/project-2.jpg"
                  }
                  title="Financial Mortagage"
                ></ProjectItem>
              </Grid>
              <Grid item md={4} xs={11} mx={"auto"}>
                <ProjectItem
                  imgUrl={process.env.PUBLIC_URL + "/img/projects/pj3.png"}
                  title="With Pride HVAC"
                ></ProjectItem>
              </Grid>
            </Grid>
          </Container>
        </Section>
      </Container>

      <Box style={{ position: "relative" }}>
        <Section elevation={0} padding={"bottom"} id="why-choose-us">
          <SectionTitle
            normal="Why"
            highlight="Choose Us ?"
            textAlign="center"
          ></SectionTitle>
          <Container>
            <Grid container spacing={5} textAlign={"center"}>
              <Grid item md={4} xs={6}>
                <WhyChooseItem
                  no={1}
                  title="We Value Our Clients"
                ></WhyChooseItem>
              </Grid>
              <Grid item md={4} xs={6}>
                <WhyChooseItem
                  no={2}
                  title="We are available for Long-Term-Partnership"
                ></WhyChooseItem>
              </Grid>
              <Grid item md={4} xs={6}>
                <WhyChooseItem
                  no={3}
                  title="We are expert at development"
                ></WhyChooseItem>
              </Grid>
              <Grid item md={4} xs={6}>
                <WhyChooseItem
                  no={4}
                  title="We make creative design"
                ></WhyChooseItem>
              </Grid>
              <Grid item md={4} xs={6}>
                <WhyChooseItem no={5} title="We meet deadline"></WhyChooseItem>
              </Grid>
              <Grid item md={4} xs={6}>
                <WhyChooseItem
                  no={6}
                  title="We have good customer service"
                ></WhyChooseItem>
              </Grid>
            </Grid>
          </Container>
        </Section>
        <Box
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}'/img/ygn-bg.png')`,
            backgroundSize: "cover",
            zIndex: -1,
            opacity: 0.1,
            position: "absolute",
            bottom: 0,
            height: "90%",
            width: "100%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        ></Box>
      </Box>
    </>
  );
};

export default Home;
